import createEnum from 'lib/createEnum';

export const SET_INTERACTIVE_ONBOARDING = 'ui/SET_INTERACTIVE_ONBOARDING';
export const WIDGET_AUTO_SHOW = 'ui/WIDGET_AUTO_SHOW';
export const WIDGET_HIDE = 'ui/WIDGET_HIDE';
export const WIDGET_INITIATE = 'ui/WIDGET_INITIATE';
export const WIDGET_MINIMIZE = 'ui/WIDGET_MINIMIZE';
export const WIDGET_SUPPRESS = 'ui/WIDGET_SUPPRESS';
export const WIDGET_UNSUPPRESS = 'ui/WIDGET_UNSUPPRESS';
export const WIDGET_UNMINIMIZE = 'ui/WIDGET_UNMINIMIZE';
export const WIDGET_UPDATE_COMPOSITION_DRAFT = 'ui/WIDGET_UPDATE_COMPOSITION_DRAFT';
export const WIDGET_UPDATE_STAGE = 'ui/WIDGET_UPDATE_STAGE';
export const WIDGET_UPDATE_VISIBILITY = 'ui/WIDGET_UPDATE_VISIBILITY';

export const STAGES = createEnum(
  'CHAT',
  'CHAT_CLOSED',
  'CHAT_THROTTLED',
  'ONBOARDING',
  'DEMO_SELF_SERVICE',
  'SELF_SERVICE'
);
